import type { OpenAIAccountSummary } from "@/api/types";

/** The linked OpenAI account the user's next turn runs on, when it is
 *  usable: the one they chose, else the newest active one (the list
 *  arrives newest first). Mirrors the backend resolver, so a new session
 *  is pinned to that account and its first turn doesn't "repoint" it. */
export function accountForTurns(
  accounts: readonly OpenAIAccountSummary[] | undefined,
): OpenAIAccountSummary | undefined {
  const list = accounts ?? [];
  return (
    list.find((a) => a.preferred && a.status === "active") ??
    list.find((a) => a.status === "active")
  );
}
